export enum SELECT_PICKUP_POINT_TRANSITIONS {
  FETCH_POINTS = 'FETCH_POINTS',
  SELECT_POINT = 'SELECT_POINT',
  OPEN = 'OPEN',
  CLOSE = 'CLOSE',
}
